var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('g-model'),_c('div',{staticClass:"tt"},[_vm._v("321321")]),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"aa"},[_c('div',[_vm._v("1")]),_c('div',[_vm._v("2")]),_c('p',[_vm._v("3")])])
}]

export { render, staticRenderFns }